declare global {
    interface Window {
        __CHAIKA_CONFIG__: {
            readonly PUBLIC_PATH: string;
        };
    }
}

// @ts-ignore

__webpack_public_path__ = window.__CHAIKA_CONFIG__.PUBLIC_PATH;

export {};
